// NEXT ID
const $$ID = +new Date
let $$id = 0

// DISTRIBUTES next ID
export function idgen () : string {
    return `${$$ID.toString(36)}_${($$id++).toString(36)}`.toUpperCase()
}

export class Identity {
    static create() : string {
        return idgen()
    }
}
